export default __webpack_public_path__ + "static/media/chevron-l.d4a21f9e.svg";